<template>
    <div class='info-container'>
        <ProductDetails :product='product' :variant_code='variant_code' :in_stock='in_stock' @updatedCartListener='updatedCartListener' @addToCartListener="addedToCart" @removedFromCartListener="removedFromCart" :hide_add_to_cart='hide_add_to_cart'/>
        <ProductDescription :product='product'/>
        <ProductDetailAttributes :product='product' :product_on_popout='product_on_popout'/>
    </div>
</template>

<script>
import Summary from '@/ecom/components/products/single_product/details/Summary.vue';
import Attributes from '@/ecom/components/products/single_product/attributes/Attributes.vue';
import ProductDetails from '@/ecom/components/products/single_product/details/ProductDetails.vue';
import ProductDescription from '@/ecom/components/products/single_product/details/ProductDescription.vue';
import ProductDetailAttributes from '@/ecom/components/products/single_product/details/ProductDetailAttributes.vue';

export default {
    components: {Summary, Attributes, ProductDetails, ProductDescription, ProductDetailAttributes},
    emits: ['updatedCartListener', 'addToCartListener', 'removedFromCartListener'],
    props: ['product', 'product_code_changed_watcher', 'redirect_on_click', 'product_on_popout', 'hide_add_to_cart'],
    data(){
        return{
            variant_code: '',
            in_stock: true
        }
    },
    methods:{
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        addedToCart(product, quantity){
           this.$emit('addToCartListener', product, quantity);
        },
        removedFromCart(product, quantity){
           this.$emit('removedFromCartListener', product, quantity);
        }
    },
    watch:{
        'product_code_changed_watcher': function(){
            this.variant_code = '';
            this.in_stock = true;
        },
        'product': function() {
            // if(this.product.variants.length === 0) {
            //     this.variant_code = this.product.code;
            //     this.in_stock = (this.product.total_stock > 0) ? true : false;
            //     this.product.variant_code = this.product.code;
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-container{
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}
</style>